import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SICOM_PATHS } from 'src/sicom-paths';
import { PrestadorAtividade, PrestadorAtividadeRequest, PrestadorCnae, PrestadorCnaeRequest, PrestadorCnaeSincronizacao } from './prestador-atividades.model';
@Injectable({ providedIn: 'root' })
export class PrestadorAtividadesService {
    private readonly http = inject(HttpClient);
    private readonly url = SICOM_PATHS.registro.prestador.atividades;
    listarCnaes(id: number, uf: string) {
        return this.http.get<PrestadorCnae[]>(`${this.url}/cnaes`, { params: { id, uf } });
    }
    opcoesCnae(termo = '') {
        return this.http.get<PrestadorCnae[]>(`${this.url}/cnaes/opcoes`, { params: { termo } });
    }
    criarCnae(r: PrestadorCnaeRequest) {
        return this.http.post<void>(`${this.url}/cnaes`, r);
    }
    removerCnae(r: PrestadorCnaeRequest) {
        return this.http.delete<void>(`${this.url}/cnaes`, { body: r });
    }
    atualizarCnaesNuvem(id: number, uf: string) {
        return this.http.post<PrestadorCnaeSincronizacao>(`${this.url}/cnaes/nuvem`, null, { params: { id, uf } });
    }
    listar(id: number, uf: string) {
        return this.http.get<PrestadorAtividade[]>(this.url, { params: { id, uf } });
    }
    opcoes() {
        return this.http.get<PrestadorAtividade[]>(`${this.url}/opcoes`);
    }
    criar(r: PrestadorAtividadeRequest) {
        return this.http.post<void>(this.url, r);
    }
    remover(r: PrestadorAtividadeRequest) {
        return this.http.delete<void>(this.url, { body: r });
    }
}
